import React, { createContext, useContext, type ReactNode } from 'react';

interface DetectedRegionContextValue {
  detectedRegionCode?: string;
}

const DetectedRegionContext = createContext<DetectedRegionContextValue | undefined>(undefined);

export const DetectedRegionProvider: React.FC<{
  children: ReactNode;
  detectedRegionCode?: string;
}> = ({ children, detectedRegionCode }) => {
  return (
    <DetectedRegionContext.Provider value={{ detectedRegionCode }}>
      {children}
    </DetectedRegionContext.Provider>
  );
};

export const useDetectedRegion = () => {
  const context = useContext(DetectedRegionContext);
  // Return empty object if context is not available (for backward compatibility)
  return context ?? {};
};